'use strict';

exports.__esModule = true;
exports.transformSpecialist = exports.specialistsTransformer = undefined;

var _avatar = require('../../src/assets/avatar.png');

var _avatar2 = _interopRequireDefault(_avatar);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var specialistsTransformer = exports.specialistsTransformer = function specialistsTransformer(specialists) {
	return (specialists || []).map(function (specialist) {
		return {
			// ...specialist,
			id: specialist.specialist_id,
			name: specialist.specialist_name,
			averageRating: specialist.specialist_average_review,
			numberOfReviews: specialist.specialist_number_of_reviews,
			specialist: specialist.specialist_title + ' ' + specialist.specialist_name,
			numberOfPeerRecommendations: specialist.specialist && specialist.specialist.number_of_recommendations,
			profileImage: specialist.specialist_attributes && specialist.specialist_attributes.profile_featured_image && specialist.specialist_attributes.profile_featured_image + '_lg.jpg' || _avatar2.default,
			iconUri: specialist.specialist_attributes && specialist.specialist_attributes.profile_featured_image && specialist.specialist_attributes.profile_featured_image + '_lg.jpg' || _avatar2.default
		};
	});
};

var transformSpecialist = exports.transformSpecialist = function transformSpecialist(specialist) {
	return {
		id: specialist.id,
		name: specialist.name,
		averageRating: specialist.average_review,
		numberOfReviews: specialist.number_of_reviews,
		specialist: specialist.name,
		numberOfPeerRecommendations: specialist.number_of_recommendations,
		profileImage: specialist.attributes && specialist.attributes.profile_featured_image && specialist.attributes.profile_featured_image + '_lg.jpg' || _avatar2.default,
		iconUri: specialist.attributes && specialist.attributes.profile_featured_image && specialist.attributes.profile_featured_image + '_lg.jpg' || _avatar2.default
	};
};